import styled from 'styled-components';

export const Card = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--gray-90);
  border-radius: 8px;

  @media (max-width: 640px) {
    min-height: auto;
  }
`;

export const Title = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  line-height: 28.8px;
  font-weight: 700;
  letter-spacing: -0.4px;
`;

export const DetailsButton = styled.button`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  line-height: 24px;
  border-top: 1px solid var(--dark-gray-line);
  padding: 16px 24px;
`;

export const ContentWrapper = styled.div<{ backgroundUrl: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  height: 100%;
  background: url(${(props) => props.backgroundUrl});
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 110px;
  border-radius: 8px 8px 0 0;

  @media (max-width: 640px) {
    gap: 24px;
  }
`;

export const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  span {
    display: block;
    font-size: 12px;
    line-height: 24px;
    color: var(--white);
    background-color: var(--gray-02);
    padding: 0 8px;
    border-radius: 4px;
  }
`;

export const TitleWrapper = styled.div`
  padding: 16px;
  gap: 4px;
  opacity: 0px;
`;
